import { render, staticRenderFns } from "./SendSmsNotification.vue?vue&type=template&id=e881f8f6&"
import script from "./SendSmsNotification.vue?vue&type=script&lang=js&"
export * from "./SendSmsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports